// Features/Collections-Section/Component.ts
import { Navigation, Swiper } from "Swiper";
class CollectionsSection extends HTMLElement {
  swiper;
  connectedCallback() {
    const { onDesktop, onMobile } = this;
    console.debug({
      onDesktop,
      onMobile,
      prevEl: this.part_prev,
      nextEl: this.part_next,
      swiper: this.part_swiper
    });
    this.swiper = new Swiper(this.part_swiper, {
      modules: [Navigation],
      direction: "horizontal",
      navigation: {
        prevEl: this.part_prev,
        nextEl: this.part_next
      },
      slidesPerView: 1.5,
      spaceBetween: 16,
      enabled: onMobile,
      breakpoints: {
        640: {
          slidesPerView: 2.5
        },
        1008: {
          slidesPerView: 3.5,
          enabled: onDesktop
        },
        1440: {
          slidesPerView: 4.5
        }
      }
    });
  }
  disconnectedCallback() {
    this.swiper.destroy();
  }
  get part_swiper() {
    return this.querySelector(`.swiper`);
  }
  get part_prev() {
    return this.querySelector(`.Collections-Control:first-child`);
  }
  get part_next() {
    return this.querySelector(`.Collections-Control:last-child`);
  }
  get onDesktop() {
    return this.dataset.layoutDesktop === "Slider";
  }
  get onMobile() {
    return this.dataset.layoutMobile === "Slider";
  }
}

// Features/Collections-Section/mod.ts
customElements.define("collections-section", CollectionsSection);
